import { useEffect } from 'react';

export function useOutsideClick(
  ref: React.RefObject<HTMLElement>,
  handler: (clickedOutsideElement: boolean) => void,
) {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      handler(!ref.current?.contains(event.target as Node));
    };

    document.addEventListener('mousedown', listener, true);
    return () => {
      document.removeEventListener('mousedown', listener, true);
    };
  }, [ref, handler]);
}
